<i18n src="../../locales/lang.json"></i18n>



<template>
  <div style="position:relative">
    <div class="row">
      <div class="col pr-5 pr-0" id="test" style="z-index:3">
        <div ref="buttonContainer" class="pl-2 pl-md-0 pb-2" id="buttonContainer">
          <div class="dropdown dropright" style="margin:auto;z-index:1000;float:left;margin-right:0px;" id="initialButton">
            <button type="button" @click="initialLoad()" class="newplus-button btn p-0 m-0" class="newplus-button btn p-0 m-0" style="border: 0; background-color: initial !important; box-shadow:none !important;" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
              <img src="/Images/Filter_Black_100x100px.png" class="button-icon" />
            </button>

            <div class="skinnedmenu dropdown-menu" id="additemsmenu">
              <div class="dropdown-submenu" v-show="tags.length>0 && this.$store.getUserPermissionLevel() > 2">
                <a href="#" class="dropdown-item dropdown-toggle" style="">{{$t('tags')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="tagFilter" @input="filterTags" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" v-on:click.prevent="addFilterButton('tag',menuItem.text, menuItem.text, menuItem.id)" class="dropdown-item" v-for="menuItem in tags">{{ menuItem.text }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-show="configurators.length > 0" class="row mt-3">
      <div class="col">
        <div id="childComponentContainer" ref="childComponentContainer"></div>
      </div>
    </div>

  </div>




</template>

<script>

  var activated = false;
  import FilterButton from './filter-button.vue'
  
  var user = "";
  var configurators = [];
  var buttons = [];
  var displayers = [];
  var tags = [];
  var tagFilter = "";

  export default {
    name: "filter-procedure",
    components: {
      FilterButton,
    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      user: {
        type: String,
        default: ""
      },
      defaultdisplay: {
        type: Number,
        default: 9
      },

    },
    data() {
      return {
        activated,
        configurators,
        buttons,
        displayers,
        tags,
        tagFilter,
        isloaded: false
      };
    },

    methods: {

      initialLoad() {
        if (this.isloaded == false) {
          this.loadtags();
          this.isloaded = true;
        }
      },
      shortenName(name) {
        var ret = name;
        if (name.length > 60)
          ret = name.substring(0, 60) + "...";
        return ret;
      },
      toggleActivation() {
        this.activated = !this.activated
      },
      handleRefresh(val) {
        this.$forceUpdate();
      }
      ,
      addConfigurator(type) {

        var ComponentClass = null;

        if (!this.hasElementOfType(this.configurators, type)) {
          //var instance = new ComponentClass({ propsData: { type: type } })

          var instance = new ComponentClass({ propsData: { type: type } })

          instance.$mount();
          instance.$on('remove', this.removeItem);
          instance.$on('remove', function (id) {
            instance.$el.remove();
          });
          instance.$on('addFilter', this.addButton);
          this.configurators.push({ id: instance.$el.id, type: type });
          this.$refs.childComponentContainer.appendChild(instance.$el);
        }
      },
      removeItem(id) {
        for (var i = 0; i < this.configurators.length; i++) {
          if (this.configurators[i].id == id) {
            this.configurators.splice(i, 1);
          }
        }
        this.$emit('change');
      },
      removeDisplayer(id) {
        for (var i = 0; i < this.displayers.length; i++) {
          if (this.displayers[i].id == id) {
            this.displayers.splice(i, 1);
          }
        }
      },
      addDisplayer(type, config, command) {

        var ComponentClass = null;

        if (command != null) {
            return;
          
        }       

        //if (!this.hasElementOfType(this.displayers, type)) {
        var instance = new ComponentClass({ propsData: { type: type } })
        instance.setConfig(config);
        instance.$mount();
        instance.$on('remove', this.removeDisplayer);
        instance.$on('remove', function (id) {
          instance.$el.remove();
        });

        instance.$on('addFilter', this.addButton);
        this.displayers.push({ id: instance.$el.id, type: type });
        this.$refs.childComponentContainer.appendChild(instance.$el);
        //}

        if (typeof (instance.rendered) != "undefined") {
          instance.rendered();
        }


      },
      removeButton(id) {
        for (var i = 0; i < this.buttons.length; i++) {
          if (this.buttons[i].id == id) {
            this.buttons.splice(i, 1);
            //alert('doFilterSearch')
            //vm.$root.$emit('doFilterSearch');
          }
        }
        this.$emit('change');
      },

      addButton(type, config, dosearch) {
        var ComponentClass = Vue.extend(FilterButton)
        var instance = new ComponentClass({
          propsData: {
            type: type
          }
        })
        instance.config = config;
        instance.$mount();
        instance.$on('remove', this.removeButton);

        instance.$on('remove', function (id) {
          instance.$el.remove();
          //alert('doSearch15')
          vm.$root.$emit('doProcedureFilterSearch');
        });
        instance.$on('activate', this.addDisplayer);
        this.$refs.buttonContainer.appendChild(instance.$el);

        var length = this.buttons.length;
        for (var i = 0; i < length; i++) {
          var btn = this.buttons[i];
          if (btn !== undefined && btn !== null && btn.type === "date" && type === "date") {
            $('#' + btn.id).remove();
            this.removeButton(btn.id);
          }
        }

        this.buttons.push({ id: instance.$el.id, type: type, config: config });

        if (dosearch == null) {
          //alert('doSearch16')
          vm.$root.$emit('doProcedureFilterSearch');
        }

        App.initComponents();
        this.$emit('change');
      },
      
      hasElementOfType(array, type) {
        var hasElementOfType = false;
        for (var i = 0; i < array.length; i++) {
          if (array[i].type == type) {
            hasElementOfType = true;
          }
        }
        return hasElementOfType;
      },
      getCurrentFilter() {
        return this.buttons;
      },
      clearFilters() {

        var children = $('#buttonContainer').children()
        for (var i = 1; i < children.length; i++) {
          children[i].remove()
        }
        this.buttons = [];
      },      
      async loadtags() {
        try {
          this.items = [];
          this.$http.get('/api/Procedures/v1/GetProceduresSiteTags?').then(async response => {
            this.tags = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.name.toLowerCase();
                var y = b.name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            else {
              this.tags.push({ id: -1, text: this.$t('no_tags_available_yet'), display: true })
            }

            for (var i = 0; i < response.data.length; i++) {
              this.tags.push({ id: response.data[i].id, text: response.data[i].name, display: true })
            }
            this.filterTags();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      
      addFilterButton(type, data, text, id) {
        if (id == -1) {
          return;
        }
        var bgStyle = "";
        var icon = null;
        var menu = null;
        var color = "";

        if (type == "tag") {
          color = "rgba(142,157,178,0.8)";
          bgStyle = "background-color:rgba(142,157,178,0.8)";
          //icon = "/images/filter_icons/icon-location.png";
        }
        var buttonData =
        {
          color: color,
          customstyle: bgStyle,
          customclass: "",
          abbreviation: getAbbreviation(text),//this.GetAbbreviation(text),
          data: data,
          icon: icon,
          text: getShortName(text),//this.GetShortName(text),
          menu: menu,
          key: type,
        };
        this.addButton(type, buttonData)
      },
      
      
      filterTags() {
        var visibleItems = 0;
        for (var i = 0; i < this.tags.length; i++) {
          if ((this.tagFilter != null && this.tagFilter != "" && this.tags[i].text.toLowerCase().indexOf(this.tagFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.tags[i].display = false;
          }
          else {
            this.tags[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "tags", this.tags);
      },
      
      getdisplay(item) {
        if (item.display == true) {
          return "display:block";
        }
        return "display:none;"
      },      
    },
    computed: {

    },
    mounted() {
      this.$on('remove', function (id) {
        var child = document.getElementById(id);

        child.remove();



      });



    },

    created: function () {

    },

    watch: {

    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>



  .filter-badge {
    line-height: 10px;
  }

  .filter-badge {
    position: absolute;
    top: -5px;
    right: 0px;
  }

  .newplus-button {
    color: #666;
    background-color: white !important;
    margin-top: 16px;
    margin-left: 5px;
  }

    .newplus-button img {
      width: 60px;
      height: 60px;
      margin-top: 5px;
    }

  .button-icon {
    width: 60px;
    height: 60px;
  }



  .btn-outline:not(.disabled):not(:disabled):not([class*="alpha-"]):hover, .newplus-button i:hover, .newplus-button i:active, .newplus-button i:focus {
    color: #000 !important;
  }

  .mobile-submenu {
    left: 0px !important;
  }

  @media (min-width: 768px) {

    .button-icon {
      width: 80px;
      height: 80px;
    }

    .mobile-submenu {
      left: 100% !important;
      position: absolute !important;
    }


    .newplus-button {
      border-color: white !important;
      background-color: white !important;
      margin-left: 17px;
      margin-top: -4px !important;
    }
  }

  .expanded-container-collapsed {
    opacity: 0;
    width: 0px;
    height: 0px;
  }

  .expanded-container-active {
    opacity: 1;
    width: 100%;
    height: 200px;
    background-color: green;
    transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -webkit-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -moz-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -o-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
  }

  /*
  .childComponentContainer .configurator {
    margin-left: 15px !important;
  }

  .childComponentContainer .configurator:nth-child(0) {
    margin-left: 0px !important;
  }
  */
  @media screen and (max-width:768px) {

    .newplus-button img {
      width: 46px;
      height: 46px;
      margin-top: 10px;
      margin-right: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/filter-procedure.vue